export default "__VITE_ASSET__Ce6U1v4t__"